module.exports = __webpack_public_path__ + "static/media/escalable-img.6b86a139.jpg";